export default __webpack_public_path__ + "static/light-e97f8753cf4f5db802d06a5e427bb563.jpeg";